module.exports = __webpack_public_path__ + "img/background-logo.2b48ce81.svg";